const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // ASP.NET Core API URL'niz

// Seçilen dili querystring'e ekler (null/boş ise hiçbir şey eklemez → base alanlar gelir).
const langQuery = (lang) => (lang ? `?lang=${encodeURIComponent(lang)}` : '');

export const menuService = {
  // Restoranın desteklediği dilleri getir (müşteri menüsü dil seçici için)
  getRestaurantLanguages: async (restaurantId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/restaurants/${restaurantId}/languages`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching restaurant languages:', error);
      return [];
    }
  },

  // Restoran bilgilerini getir
  getRestaurant: async (restaurantId, lang = null) => {
    try {
        if (restaurantId === 'siraze') {
            window.location.href = 'https://www.alacatikapicisi.com/ordermenu/menu/77678F12-FF83-4DFC-82E3-1C2A2DFA604F?lang=tr';
            return;
        }
        if (restaurantId === '7A3306AC3-9C62-4027-9BE3-C67F3D06DC6E') {
            restaurantId = 'A3306AC3-9C62-4027-9BE3-C67F3D06DC6E';
        }
        if (restaurantId === 'eced64b0-1e76-4940-a423-09a5c4c13baf' || restaurantId === 'ECED64B0-1E76-4940-A423-09A5C4C13BAF') {
            window.location.href = 'https://weonix.co/mialive';
            return;
        }

        const response = await fetch(`${API_BASE_URL}/api/restaurants/${restaurantId}${langQuery(lang)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching restaurant:', error);
      // Fallback data if API fails
      return {
        id: restaurantId,
        name: "Restoran",
        description: "Lezzetli yemekler burada!",
        primaryColor: "#FF6B35",
        logo: "🍽️"
      };
    }
  },

  // Restoran kategorilerini getir
  getCategories: async (restaurantId, lang = null) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/categories/restaurant/${restaurantId}${langQuery(lang)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      // Fallback categories if API fails
      return [
        { id: 'kahvalt', name: 'Kahvaltılar', icon: '☀️', color: 'bg-yellow-100' },
        { id: 'tostlar', name: 'Tostlar', icon: '🍞', color: 'bg-orange-100' },
        { id: 'burger', name: 'Burger', icon: '🍔', color: 'bg-red-100' },
        { id: 'pastalar', name: 'Pastalar', icon: '🍰', color: 'bg-pink-100' },
        { id: 'icecekler', name: 'İçecekler', icon: '🥤', color: 'bg-blue-100' }
      ];
    }
  },

  // Restoran ürünlerini getir
  getProducts: async (restaurantId, lang = null) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/products/restaurant/${restaurantId}${langQuery(lang)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching products:', error);
      // Fallback products if API fails
      return [
        {
          id: '1',
          categoryId: 'burger',
          name: 'Alsancak Burger',
          description: 'Dana eti, cheddar peyniri, marul, domates, özel sos',
          price: 38,
          image: '/MenuResim/alsancak-burger.jpg',
          isVegetarian: false,
          isSpicy: false,
          preparationTime: 15,
          rating: 4.8,
          ingredients: 'Dana eti, cheddar peyniri, marul, domates, soğan, turşu, özel burger sosu',
          calories: 650
        },
        {
          id: '2',
          categoryId: 'burger',
          name: 'Mini Çocuk Burger',
          description: 'Çocuklar için özel hazırlanmış mini burger',
          price: 29,
          image: '/MenuResim/mini-burger.jpg',
          isVegetarian: false,
          isSpicy: false,
          preparationTime: 10,
          rating: 4.6,
          ingredients: 'Dana eti, mild cheddar, marul, domates',
          calories: 450
        },
        {
          id: '3',
          categoryId: 'burger',
          name: 'Veggie Deluxe',
          description: 'Sebze köftesi, avokado, roka, özel vegan sos',
          price: 35,
          image: '/MenuResim/veggie-burger.jpg',
          isVegetarian: true,
          isSpicy: false,
          preparationTime: 12,
          rating: 4.4,
          ingredients: 'Sebze köftesi, avokado, roka, domates, vegan sos',
          calories: 520
        },
        {
          id: '4',
          categoryId: 'burger',
          name: 'Spicy BBQ Burger',
          description: 'Acılı BBQ soslu dana burger, jalapeño',
          price: 42,
          image: '/MenuResim/spicy-burger.jpg',
          isVegetarian: false,
          isSpicy: true,
          preparationTime: 18,
          rating: 4.7,
          ingredients: 'Dana eti, BBQ sos, jalapeño, cheddar, soğan halkası',
          calories: 720
        },
        {
          id: '5',
          categoryId: 'tostlar',
          name: 'Klasik Tost',
          description: 'Kaşar peyniri ve sucuklu tost',
          price: 18,
          image: '/MenuResim/klasik-tost.jpg',
          isVegetarian: false,
          isSpicy: false,
          preparationTime: 8,
          rating: 4.3,
          ingredients: 'Ekmek, kaşar peyniri, sucuk',
          calories: 380
        },
        {
          id: '6',
          categoryId: 'icecekler',
          name: 'Taze Portakal Suyu',
          description: 'Günlük sıkılmış taze portakal suyu',
          price: 15,
          image: '/MenuResim/portakal-suyu.jpg',
          isVegetarian: true,
          isSpicy: false,
          preparationTime: 3,
          rating: 4.9,
          ingredients: 'Taze portakal',
          calories: 120
        }
      ];
    }
  },

  // QR kod erişim logunu kaydet
  logAccess: async (qrCodeId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/menuqrcodes/${qrCodeId}/access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error logging access:', error);
      // Bu hata kritik değil, sessizce geç
    }
  },

  // QR kod bilgilerini getir
  getQrCodeInfo: async (restaurantId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/menuqrcodes/restaurant/${restaurantId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching QR code info:', error);
      throw error;
    }
  }
};

export default menuService;
